/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsLauncherReviewSettings } from './FxIdDomainSettingsLauncherReviewSettings';
import {
    instanceOfFxIdDomainSettingsLauncherReviewSettings,
    FxIdDomainSettingsLauncherReviewSettingsFromJSON,
    FxIdDomainSettingsLauncherReviewSettingsFromJSONTyped,
    FxIdDomainSettingsLauncherReviewSettingsToJSON,
} from './FxIdDomainSettingsLauncherReviewSettings';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsReviewSettings
 * 
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsReviewSettings = FxIdDomainSettingsLauncherReviewSettings;

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsReviewSettingsFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsReviewSettings {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsReviewSettingsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsReviewSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsReviewSettings {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsLauncherReviewSettings(json)) {
        return FxIdDomainSettingsLauncherReviewSettingsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsReviewSettingsToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsReviewSettingsToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsReviewSettingsToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsReviewSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsLauncherReviewSettings(value)) {
        return FxIdDomainSettingsLauncherReviewSettingsToJSON(value as FxIdDomainSettingsLauncherReviewSettings);
    }

    return {};
}

